import { api } from './api.js';

/** Ask the DemandJet API to email this event. Failures stay on screen as a normal save. */
export function reportAppNotification(body) {
  return api.post('/server/client_api/notifications', body).catch(() => null);
}

export function reportLockerUsage(usage) {
  if (!usage) return Promise.resolve(null);
  return reportAppNotification({
    kind: 'evidenceLockerNearingLimit',
    ratio: usage.ratio,
    used: usage.gbLimit ? `${Number(usage.usedGb || 0).toFixed(2)} GB` : '',
    limit: usage.gbLimit ? `${usage.gbLimit} GB` : '',
  });
}
